import type { VerticalType } from './consts';
import { VERTICAL_PATHS } from './consts';

interface Item {
  id: string;
  name: string;
  html: string;
  description: string;
  imageSrc: string;
}

const fetchCreator = (
  type: VerticalType,
  instance: string,
  locale: string,
  options?: { limit?: number; filter?: string }
): Promise<any> => {
  let url = `/_serverless/vertical-oembed/query-${VERTICAL_PATHS[type]}?language=${locale}`;
  if (options?.limit) {
    url += `&limit=${options.limit}`;
  }
  if (options?.filter) {
    url += `&filter=${options.filter}`;
  }

  return typeof fetch === 'function'
    ? fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: instance,
        },
      }).then(res => {
        if (res.ok) {
          return res.json();
        } else {
          throw res.statusText;
        }
      })
    : Promise.resolve(false);
};

const getItems = (
  type: VerticalType,
  instance: string,
  locale: string,
  options?: { limit?: number; filter?: string }
): Promise<Item[]> => {
  return fetchCreator(type, instance, locale, options).then(response => {
    if (response.status) {
      return response.status === 'success' ? response.data : [];
    }
    // support legacy api
    return response;
  });
};

abstract class AbstractVerticalSearchModule {
  isVerticalInstalled!: Promise<boolean>;

  items!: Promise<Item[]>;

  abstract search(searchInput: string): Promise<Item[]>;
}
export default class VerticalSearchModule extends AbstractVerticalSearchModule {
  constructor(
    private verticalType: VerticalType,
    private instance: string,
    private locale: string,
    private limit?: number
  ) {
    super();
  }

  isInstalled(): Promise<boolean> {
    if (!this.isVerticalInstalled) {
      this.isVerticalInstalled = fetchCreator(this.verticalType, this.instance, this.locale, {
        limit: 0,
      }).then(res => !res.errMsg);
    }
    return this.isVerticalInstalled;
  }

  search(searchInput: string): Promise<Item[]> {
    if (this.verticalType === 'product' || this.verticalType === 'event') {
      return getItems(this.verticalType, this.instance, this.locale, {
        limit: this.limit,
        filter: searchInput,
      });
    }
    if (!this.items) {
      this.items = getItems(this.verticalType, this.instance, this.locale, { limit: this.limit });
    }
    return this.items.then(res =>
      res.filter(item => item.name.toLowerCase().includes(searchInput.toLowerCase()))
    );
  }
}
